<div class="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
  <div>
    <h2 class="page-title">{{ title }}</h2>
    <p class="page-subtitle" *ngIf="subTitle">{{ subTitle }}</p>
  </div>
</div>